import e from "react";
import { ChevronRight as l } from "@olxbr/ds-icons";
import { Avatar as n } from "../../../Avatar/Avatar.js";
const m = _ref => {
  let {
    link: a,
    userName: t,
    profilePicture: r
  } = _ref;
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "olx-header__desktop-wrapper"
  }, e.createElement(n, {
    size: "32px",
    src: r
  }), e.createElement("div", {
    className: "olx-header__info"
  }, e.createElement("span", {
    className: "olx-header__name"
  }, t.split(" ")[0]), e.createElement("span", {
    className: "olx-header__account"
  }, "Minha Conta")), e.createElement("span", {
    className: "olx-header__icon-wrapper"
  }, e.createElement(l, null))), e.createElement("div", {
    className: "olx-header__tablet-wrapper"
  }, e.createElement(a.Icon, {
    size: "16"
  }), a.title));
};
export { m as MyCadastre };